// Named authors used for article bylines and Article/Person schema.
// A named author with a contactable email is a core E-E-A-T signal and is used
// by every competing page currently ranking for Singapore personal trainer rates.
export const harveyFinn = {
    id: 'harvey-finn',
    name: 'Harvey Finn',
    email: 'harveyfinn@stringssg.com',
    jobTitle: 'Fitness Content Lead, StringsSG',
    bio: 'Harvey Finn covers personal training pricing and the Singapore fitness market for StringsSG, working with the platform booking data and published market rates to keep this guide current.',
    knowsAbout: [
        'Personal training',
        'Personal trainer rates in Singapore',
        'Fitness coaching',
        'Singapore fitness market',
    ],
}

export const authors = {
    [harveyFinn.id]: harveyFinn,
}
